import { CHANGE_SELECTED_PORTFOLIO_TABLE } from '../actionConstants/portfolioConstants';

// eslint-disable-next-line
export const changeSelectedPortfolioAutoTradeTable = ({ tableId }) => ({
  type: CHANGE_SELECTED_PORTFOLIO_TABLE,
  payload: { tableId },
});
